import { useState } from 'react';
import Input, { type InputProps } from '@/components/base/Input';

interface PasswordFieldProps extends InputProps {
  showLabel: string;
  hideLabel: string;
}

export default function PasswordField({ showLabel, hideLabel, ...props }: PasswordFieldProps) {
  const [show, setShow] = useState(false);

  return (
    <Input
      {...props}
      type={show ? 'text' : 'password'}
      ltr
      trailing={
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          aria-label={show ? hideLabel : showLabel}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-400 hover:bg-background-100"
        >
          <i className={show ? 'ri-eye-off-line text-lg' : 'ri-eye-line text-lg'} aria-hidden="true" />
        </button>
      }
    />
  );
}